export const STORE_OPTION_TYPES = {
  DELIVERY: 'delivery',
  TAKEAWAY: 'takeaway',
}